import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { MainLayout } from "layouts";
import {
  addCircularFilter,
  deleteCircularFilter,
  getAllCircularFilters,
  getCircularFilterById,
  getTiers,
  updateCircularFilter,
} from "api";
import { useAuthContext, useCircularContext } from "contexts";
import { Flex, Table, Button, Typography, Modal } from "antd";
import { FilterSectionModal } from "./Components/FilterSectionModal";
import { navigate } from "@reach/router";
import { stringify } from "query-string";

export const CicrularFilters = () => {
  const { userInfo } = useAuthContext();
  const [circularFiltersData, setCircularFiltersData]= useState([])
  const [tiers, setTiers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isApplyLoading, setIsApplyLoading] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterMode, setFilterMode] = useState('create');
  const [filterId, setFilterId] = useState(null);
  const [filterName, setFilterName] = useState('');
  const [filterValue, setFilterValue] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const {
      setFilter
    } = useCircularContext();

  if (!userInfo && !userInfo.user.is_superuser) {
    navigate("/home");
  }

  const getAllCircularFiltersData = async () => {
    setIsLoading(true);
    const res = await getAllCircularFilters();
    if (res.success) {
      setCircularFiltersData(res.results);
    } 
    setIsLoading(false);
  }
  
  const init = async () => {
    getAllCircularFiltersData();

    const res = await getTiers();
    if (res.success) {
      const tiersMapped = res.results.tiers.map((item) => ({
        ...item,
        title: item.ext_id,
        id: item.ext_id
      }));
      setTiers(tiersMapped);
    };
  }

   useEffect(() => {
      init();
      return () => {};
    }, []);


  const handleCreateFilter = () => {
    setShowFilterModal(true);
    setFilterMode('create');
  }

  const handleUpdate = async (id) => {
    setFilterId(id);
    setIsUpdateLoading(true);
    const res = await getCircularFilterById(id);
    if (res.success) {
      setFilterMode('update');
      setFilterName(res.results.filter_name);
      setFilterValue(res.results.filter_value);
      setShowFilterModal(true);
    }
    setIsUpdateLoading(false);
  }

  const handleApply = async (id) => {
    setFilterId(id);
    setIsApplyLoading(true);
    const res = await getCircularFilterById(id);
    setIsApplyLoading(false);
    const filter_value = res.results.filter_value;
    const retailer_id = filter_value.retailerIds.map(item => item.value).join(',');

    setFilter({
      retailerId: retailer_id, stage: filter_value.stage, tier: filter_value.tier, circType: filter_value.circType,
      creationDateFrom: filter_value.creationDateFrom, creationDateTo: filter_value.creationDateTo,
      circDateFrom: filter_value.circDateFrom, circDateTo: filter_value.circDateTo,
      adBlocksCount: filter_value.adBlocksCount, activeRetailers: filter_value.activeRetailers
    });

    navigate(
      `/circular/?${stringify({
        retailerId: retailer_id
      })}`
    );
  }

  const handleDelete = async (id) => {
    setFilterId(id)
    setOpenDeleteModal(true);
  }

  const handleCancel = () => {
    setFilterId(null);
    setOpenDeleteModal(false);
  }

  const deleteFilter = async () => {
    setIsDeleteLoading(true);
    const res = await deleteCircularFilter(filterId);
    setIsDeleteLoading(false);
    setOpenDeleteModal(false);
    getAllCircularFiltersData();
  }

  const saveFilters = async (filterName, filters) => {

    if (filterMode === 'create') {
      const res = await addCircularFilter(
        {
          filter_name: filterName,
          filter_value: filters,
          created_by: userInfo.user.id,
          updated_by: userInfo.user.id
        })
    }
    else {
      const res = await updateCircularFilter(
        filterId,
        {
          filter_name: filterName,
          filter_value: filters,
          updated_by: userInfo.user.id

        })
    }

    setShowFilterModal(false)
    getAllCircularFiltersData();
  }


  const columns = [
    {
      title: 'Filter ID', dataIndex: 'filter_id', key: '', width: '0%', hidden: true
    },
    {
      title: 'Filter Name', dataIndex: 'filter_name', key: '', width: '23%'
    },
    {
      title: 'Created By', dataIndex: 'created_by', key: '', width: '23%',
    },
    { title: 'Updated By', dataIndex: 'updated_by', key: '', width: '23%' },
    {
      title: 'Actions', key: 'action', align: 'center',
      render: (_, record) => (
        <>
          <Button key='apply' variant="solid" color="primary" loading={isApplyLoading && record.filter_id === filterId} onClick={() => handleApply(record.filter_id)}>Apply</Button>
          <Button key='update' variant="link" color="cyan" loading={isUpdateLoading && record.filter_id === filterId} onClick={() => handleUpdate(record.filter_id)}>Update</Button>
          <Button key='delete' color="danger" variant="link" loading={isDeleteLoading && record.filter_id === filterId} onClick={() => handleDelete(record.filter_id)}>Delete</Button>
        </>
      )
    },
  ];

  return (
    <MainLayout>
      <MainContent>
          <FilterSectionModal filter_name={filterName} filter_value={filterValue} mode={filterMode} isOpen={showFilterModal} onOk={saveFilters} tiers={tiers} onCancel={() => setShowFilterModal(false)} />
        <TableSection>
          <Flex vertical>
            <Table key='filter-table' bordered loading={isLoading} size="medium" tableLayout="auto" style={{ 'marginRight': '0.2%' }}
              dataSource={circularFiltersData} columns={columns} 
              pagination={{ defaultPageSize: 50 }}
                     title={() => (
                              <Flex className="" align="end" justify="space-between">
                                <div>
                                  <Typography.Title level={4}> Circular Filters</Typography.Title>
                                </div>
                                 
                                    <Button type="primary" onClick={handleCreateFilter}>Create New Filter</Button>
                                  
                                  
                              </Flex>
                            )}

            ></Table>
          </Flex>
        </TableSection>
      </MainContent>

      <Modal key='delete-filter' size="small" title={"Delete Filter"} style={{
        top: 0,
        right: 0,
        position: 'centered',
      }}
        open={openDeleteModal}
        onOk={deleteFilter}
        footer={[
          <Button key="back" onClick={handleCancel}>Cancel</Button>,
          <Button variant="solid" color="danger" loading={isDeleteLoading} onClick={deleteFilter}>
            Delete
          </Button>,
        ]}
        onCancel={handleCancel}>
        <div>Are you sure you want to delete this filter?</div>
      </Modal>

    </MainLayout>
  );
}

const MainContent = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: auto;
  background: ${(props) => props.theme.palette.backgrounds};
`;

const SideSection = styled.div`
  margin-top: 30px;
  width: 300px;
  border-right: 3px solid ${(props) => props.theme.palette.canvas};
  display: flex;
  flex-direction: column;

  .ant-select-show-search
  {
  max-width: 500px !important;
  }

  button {
    margin-top: 0px;
    margin-left: 24px;
    height: 50px !important;
    align-items: center;
  }
  
  .wrapper {
    overflow: auto;
    margin: 12px 12px 12px 24px;
    padding-right: 10px;
    min-width: 240px;
    ::-webkit-scrollbar {
      width: 10px;
      background: ${(props) => props.theme.palette.background};
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${(props) => props.theme.palette.background};
      border: 1px solid ${(props) => props.theme.palette.itemsHover};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.palette.itemsHover};
      cursor: pointer;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
      cursor: pointer;
    }
  }

  .title {
    color:white;
    font-size:12px;
    border-bottom: 1px solid ${(props) => props.theme.palette.itemsHover};
    text-transform:uppercase;
  }
`;

const TableSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-top: 30px;
  margin-right: 20px;
  margin-bottom: 20px;
`;
